<ng-template [ngIf]="debug$ | async">
  <button (click)="allPoint()">All Red points</button>
  <button (click)="setPoint('update_schedule')">update_schedule</button>
  <button (click)="setPoint('classroom_new_invitation')">classroom_new_invitation</button>
  <button (click)="setPoint('sidebar_my_classes')">sidebar_my_classes</button>
</ng-template>
